// extracted by mini-css-extract-plugin
export default {"mshop_logo_with_menu":"mshop_logo_with_menu__fd4ca623","menu_icon":"menu_icon__fd4ca623","shop_icon":"shop_icon__fd4ca623","transparent":"transparent__fd4ca623"};